<template>
  <div
    class="app-shell flex min-h-screen flex-col bg-background text-foreground"
    :class="{ 'pb-[calc(3.25rem+env(safe-area-inset-bottom,0px))] md:pb-0': reserveMobileNavbarSpace }"
  >
    <div class="app-shell__body flex min-h-0 flex-1">
      <AppDesktopSidebar v-if="client.isAuthenticated" class="app-shell__sidebar sticky top-0 hidden h-screen shrink-0 md:block" />
      <main class="app-shell__main min-w-0 flex-1">
        <slot />
      </main>
    </div>
    <MobileAppNavbar v-if="showMobileNavbar" />
    <ListingPreviewDrawer />
  </div>
</template>

<script setup lang="ts">
import AppDesktopSidebar from "~/components/layout/AppDesktopSidebar.vue";
import ListingPreviewDrawer from "~/components/listing/ListingPreviewDrawer.vue";
import { useFavoritesCount } from "~/composables/use-favorites-count";
import { useClient } from "~/stores/client";

const client = useClient();
useFavoritesCount();
const route = useRoute();

const showMobileNavbar = computed(() => client.isAuthenticated && !route.meta.hideMobileNavbar);
const reserveMobileNavbarSpace = computed(() => {
  return showMobileNavbar.value && !route.path.startsWith('/feed') && !route.meta.mobileFullscreen;
});

</script>
